import { useFlag } from "@unleash/proxy-client-react";

/**
 * Unleash release toggle gating the client-side PII redaction feature (LAR-27):
 * chat send-gate + NER model prewarm, the "Godkendte ord" whitelist admin
 * surfaces, the PII notification toggle, override-audit recording and the
 * Insights override badge.
 *
 * OFF = the feature is invisible and inert (business kill-switch): messages
 * send directly without scanning. The send-gate's fail-closed behaviour
 * applies only while the feature is ON.
 *
 * Keep the literal flag name in this file only.
 */
export const PII_REDACTION_FEATURE_FLAG = "PII-Redaction";

const usePiiFeatureEnabled = (): boolean => useFlag(PII_REDACTION_FEATURE_FLAG);

export default usePiiFeatureEnabled;
